<template>
  <div
    class="base-input-file"
    :class="classObject"
  >
    <input
      ref="input"
      type="file"
      class="base-input-file__input-file"
      :accept="accept"
      :name="name"
      @change="onChange($event)"
    >
    <div
      class="base-input-card__button"
      :class="{'base-input-card__button--filled': fileName}"
      @click="onClick()"
    >
      <template v-if="!fileName">
        <font-awesome-icon
          class="base-input-card__button__icon"
          :icon="icon"
        />
        <div>{{ label }}</div>
      </template>
      <template v-if="fileName">
        <font-awesome-icon
          class="base-input-card__button__icon"
          icon="file"
        />
        <div>{{ fileName }}</div>
      </template>
    </div>
    <div
      v-if="message"
      class="base-input-file__feedback text-center py-1"
    >
      {{ message }}
    </div>
  </div>
</template>
<script>
import BaseInputFile from './BaseInputFile.vue';

export default {
  name: 'BaseInputFileCard',
  extends: BaseInputFile,
  props: {
    icon: {
      type: String,
      default: 'plus',
    },
  },
};
</script>
<style lang="scss">
.base-input-card__button {
    background: #eee;
    border-radius: 3px;
    padding: 1rem;
    text-align: center;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: background .3s ease;
    &:hover {
        background: #ccc;
    }
}
.base-input-card__button__icon{
    margin-right: 0.5rem;
}
.base-input-card__button--filled {
    background: rgba($primary, 0.1);
    color: $primary;
}
.base-input-file-card--error .base-input-card__button {
    background: rgba($danger, 0.3);
    color: $danger;
}
.base-input-file-card--success .base-input-card__button {
    background: rgba($success, 0.3);
    color: $success;
}
.base-input-file-card--error .base-input-file__feedback {
    color: $danger;
}
.base-input-file-card--success .base-input-file__feedback {
    color: $success;
}
</style>
